import { NumberField } from '@automata/ui';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { selectLabwareColorIndexById } from '../../../../../features/selectors';
import { useAppSelector } from '../../../../../hooks';
import type { LabwareProperties } from '../../../../../types';
import { getColorFromIndex } from '../../../../../utils';
import { FormSectionLabel } from '../../FormSectionLabel';
import HeaderCell from '../../HeaderCell/HeaderCell';
import LabwareCellContent from '../../LabwareCellContent/LabwareCellContent';
import PropertiesTableStyled from '../../PropertiesTableStyled/PropertiesTableStyled';

type Props = {
  reusableLabware: LabwareProperties[];
  onChange: ({
    labwareId,
    unitsConsumed,
  }: {
    labwareId: string;
    unitsConsumed: number | null;
  }) => void;
  unitsConsumedByLabware: { [labwareId: string]: number | null | undefined };
};

export const UnitsConsumedTable = ({
  reusableLabware,
  onChange,
  unitsConsumedByLabware,
}: Props): JSX.Element | null => {
  const colorIndexes = useAppSelector(selectLabwareColorIndexById);

  return (
    <Box paddingY={2}>
      <FormSectionLabel>Labware Usage</FormSectionLabel>
      <Stack>
        <PropertiesTableStyled>
          <TableHead>
            <TableRow>
              <HeaderCell>Labware</HeaderCell>
              <HeaderCell tooltipText="Specify the units consumed for this task.">
                Units Consumed
              </HeaderCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {reusableLabware.map((labware) => (
              <TableRow key={labware.id}>
                <TableCell>
                  <LabwareCellContent
                    color={getColorFromIndex(colorIndexes[labware.id] ?? 0)}
                  >
                    {labware.nickname}
                  </LabwareCellContent>
                </TableCell>

                <TableCell>
                  <NumberField
                    min={1} // TODO - Add validation to ensure units consumed is a positive integer
                    value={unitsConsumedByLabware[labware.id]}
                    onChange={(e) => {
                      onChange({
                        labwareId: labware.id,
                        unitsConsumed: e,
                      });
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </PropertiesTableStyled>
      </Stack>
    </Box>
  );
};
